import React from 'react';
import { element, number, shape, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import {
  Card,
  CardTitle,
  CardFootnote,
} from '@thd-olt-component-react/core-ui';
import { TopCategories } from '@thd-olt-component-react/thd-recs-containers';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

import { CUSTOMER_TYPES } from '../../utils';

const styles = classnames.bind(componentStyles);

export function CustomRenderedTopCategoriesForYou({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
  REQUEST_KEY,

  mcvisID,
  slidesPer,
  customerType,
}) {
  const parsedCustomerType = (
    customerType === CUSTOMER_TYPES.B2B ? customerType : CUSTOMER_TYPES.B2C
  ).toUpperCase();

  return (
    <QueryProvider cacheKey="pers_topCategories">
      <Hydrator
        id="topCategoriesForYou-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <Card>
          {/**
           * @TODO
           * Refactor `app.scss` to use CSS modules.
           */}
          <CardTitle
            className="card__title u-width-100"
            title="Top Categories For You"
          />
          <TopCategories
            hideTitle
            requestKey={REQUEST_KEY}
            schema="pers_topCategories"
            apiName="pers_topCategories"
            showLoading
            customerID={mcvisID}
            slidesPer={slidesPer}
            customerType={parsedCustomerType}
          />
          <CardFootnote
            alignment="right"
            className={styles('component__footnote')}
            footnote="Based on your browsing and purchase history"
          />
        </Card>
      </Hydrator>
    </QueryProvider>
  );
}

CustomRenderedTopCategoriesForYou.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,
  REQUEST_KEY: string,

  mcvisID: string,
  slidesPer: number,
  customerType: string,
};

CustomRenderedTopCategoriesForYou.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,
  REQUEST_KEY: undefined,

  mcvisID: undefined,
  slidesPer: undefined,

  customerType: undefined,
};
